<template>
  <div class="bg-white dark:bg-slate-800 border-b dark:border-gray-700 px-4 py-3">
    <!-- Ligne 1: Filtre par agent -->
    <div class="flex items-center gap-3 mb-3">

      <!-- Label et compteur total -->
      <!-- <div class="flex items-center gap-2 flex-shrink-0">
        <i class="las la-filter text-gray-500 dark:text-gray-400 text-lg"></i>
        <span class="text-sm font-medium text-gray-700 dark:text-gray-300">
          Par agent
        </span>
        <span v-if="users.length > 0"
          class="px-2 py-0.5 text-xs font-medium bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-full">
          {{ users.length }}
        </span>
      </div> -->

      <!-- Multiselect -->
      <div class="flex-1 min-w-0">
        <multiselect v-model="filterData" @select="setFilterAssignConversation" @remove="clearFilter" :options="users"
          :allow-empty="true" :option-height="60" :show-labels="false" label="firstname" track-by="id"
          :loading="isLoading" placeholder="Tous les agents" selectLabel="Sélectionner" deselectLabel="Retirer"
          class="multiselect-custom">

          <!-- Label sélectionné -->
          <template #singleLabel="{ option }">
            <div class="flex items-center justify-between w-full py-1">
              <div class="flex items-center gap-2 min-w-0 flex-1">
                <!-- Avatar coloré -->
                <div
                  class="w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center text-white text-xs font-semibold shadow-sm"
                  :style="{ backgroundColor: option?.color || '#6B7280' }">
                  {{ getInitials(option) }}
                </div>

                <!-- Nom -->
                <span class="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">
                  {{ option.firstname }} {{ option.lastname }}
                </span>
              </div>

              <!-- Badge compteur -->
              <div class="flex items-center gap-1.5 flex-shrink-0 ml-2">
                <span
                  class="px-2 py-0.5 text-xs font-semibold rounded-full bg-teal-50 dark:bg-teal-900/30 text-teal-600 dark:text-teal-400">
                  {{ option.conversations_count || 0 }}
                </span>
              </div>
            </div>
          </template>

          <!-- Options dans la liste déroulante -->
          <template #option="{ option }">
            <div
              class="flex items-center justify-between w-full py-2 px-1 hover:bg-gray-50 dark:hover:bg-gray-700/50 rounded transition-colors">
              <div class="flex items-center gap-3 min-w-0 flex-1">
                <!-- Avatar coloré -->
                <div
                  class="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center text-white text-sm font-semibold shadow-sm ring-2 ring-white dark:ring-gray-800"
                  :style="{ backgroundColor: option?.color || '#6B7280' }">
                  {{ getInitials(option) }}
                </div>

                <!-- Infos agent -->
                <div class="min-w-0 flex-1">
                  <div class="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">
                    {{ option.firstname }} {{ option.lastname }}
                  </div>
                  <div class="text-xs text-gray-500 dark:text-gray-400">
                    {{ option.email || 'Aucun email' }}
                  </div>
                </div>
              </div>

              <!-- Badge compteur avec texte -->
              <div class="flex items-center gap-1.5 flex-shrink-0 ml-3">
                <div class="text-right">
                  <div class="text-xs font-semibold text-gray-900 dark:text-gray-100">
                    {{ option.conversations_count || 0 }}
                  </div>
                  <div class="text-[10px] text-gray-500 dark:text-gray-400">
                    conv{{ (option.conversations_count || 0) > 1 ? 's' : '' }}
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- État de chargement -->
          <template #beforeList>
            <div v-if="isLoading" class="flex items-center justify-center py-4">
              <div class="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                <div
                  class="w-4 h-4 border-2 border-gray-300 dark:border-gray-600 border-t-teal-500 rounded-full animate-spin">
                </div>
                <span>Chargement des agents...</span>
              </div>
            </div>
          </template>

          <!-- Aucun résultat -->
          <template #noResult>
            <div class="flex flex-col items-center justify-center py-6 px-4 text-center">
              <i class="las la-user-slash text-3xl text-gray-400 dark:text-gray-500 mb-2"></i>
              <p class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Aucun agent trouvé
              </p>
              <p class="text-xs text-gray-500 dark:text-gray-400">
                Essayez avec un autre terme de recherche
              </p>
            </div>
          </template>

          <!-- Aucune option disponible -->
          <template #noOptions>
            <div class="flex flex-col items-center justify-center py-6 px-4 text-center">
              <i class="las la-users-slash text-3xl text-gray-400 dark:text-gray-500 mb-2"></i>
              <p class="text-sm font-medium text-gray-700 dark:text-gray-300">
                Aucun agent disponible
              </p>
            </div>
          </template>
        </multiselect>
      </div>

      <!-- Bouton reset du filtre agent -->
      <button v-if="filterData" @click="clearFilter" type="button"
        class="flex-shrink-0 p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
        title="Réinitialiser le filtre agent">
        <i class="las la-times text-lg"></i>
      </button>
    </div>

    <!-- Ligne 2: Filtre par plage de dates -->
    <div class="flex items-center gap-3 flex-wrap">
      <!-- Label -->
      <!-- <div class="flex items-center gap-2 flex-shrink-0">
        <i class="las la-calendar text-gray-500 dark:text-gray-400 text-sm"></i>
        <span class="text-xs font-medium text-gray-700 dark:text-gray-300">
          Par date
        </span>
      </div> -->

      <!-- Sélecteurs de date et heure -->
      <div class="flex flex-col gap-2 flex-1">
        <!-- Première ligne : Date de début -->
        <div class="flex items-center gap-2 bg-gray-50 dark:bg-gray-700/50 rounded-lg px-2 py-1.5 text-xs w-full sm:w-auto">
          <span class="text-gray-600 dark:text-gray-400 whitespace-nowrap">De:</span>
          <input
            type="date"
            v-model="startDate"
            @change="onStartDateChange"
            class="px-2 py-1 text-xs border rounded dark:bg-slate-700 dark:border-gray-600 dark:text-gray-300 focus:ring-2 focus:ring-teal-500 focus:border-transparent"
            title="Date de début"
          />
          <input
            type="time"
            v-model="startTime"
            @change="updateStartDateFilter"
            class="px-2 py-1 text-xs border rounded dark:bg-slate-700 dark:border-gray-600 dark:text-gray-300 focus:ring-2 focus:ring-teal-500 focus:border-transparent"
            title="Heure de début"
          />
        </div>

        <!-- Deuxième ligne : Date de fin + bouton clear + compteur -->
        <div class="flex items-center gap-2 flex-wrap">
          <div class="flex items-center gap-2 bg-gray-50 dark:bg-gray-700/50 rounded-lg px-2 py-1.5 text-xs flex-1 sm:flex-none">
            <span class="text-gray-600 dark:text-gray-400 whitespace-nowrap">À:</span>
            <input
              type="date"
              v-model="endDate"
              @change="onEndDateChange"
              class="px-2 py-1 text-xs border rounded dark:bg-slate-700 dark:border-gray-600 dark:text-gray-300 focus:ring-2 focus:ring-teal-500 focus:border-transparent"
              title="Date de fin"
            />
            <input
              type="time"
              v-model="endTime"
              @change="updateEndDateFilter"
              class="px-2 py-1 text-xs border rounded dark:bg-slate-700 dark:border-gray-600 dark:text-gray-300 focus:ring-2 focus:ring-teal-500 focus:border-transparent"
              title="Heure de fin"
            />
            <button
              v-if="startDate || endDate"
              @click="clearDateFilter"
              class="ml-1 p-1 text-red-600 dark:text-red-400 hover:bg-red-200 dark:hover:bg-red-900/50 rounded transition-colors flex-shrink-0"
              title="Effacer le filtre de date"
            >
              <i class="las la-times"></i>
            </button>
          </div>

          <!-- Compteur de résultats -->
          <div class="flex items-center gap-1.5 px-3 py-1.5 bg-teal-50 dark:bg-teal-900/20 rounded-lg text-xs">
            <i class="las la-list-alt text-teal-600 dark:text-teal-400"></i>
            <span class="font-medium text-teal-700 dark:text-teal-300">
              {{ pagination?.total || 0 }} résultat{{ (pagination?.total || 0) > 1 ? 's' : '' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import Multiselect from 'vue-multiselect'

export default {
  name: "InboxFilter",
  components: { Multiselect },
  data() {
    return {
      filterData: null,
      startDate: null,
      startTime: '00:00',
      endDate: null,
      endTime: '23:59',
    }
  },
  computed: {
    ...mapFields("users/list", {
      isLoading: "isLoading",
      users: "items",
      isSuccess: "isSuccess",
      message: "message",
      showMessage: "showMessage",
    }),
    ...mapFields("conversations/list", {
      filter: "filter",
      pagination: "pagination",
    }),
    ...mapFields("conversations/update", {
      conversationIsUpdated: "isUpdated",
    }),
  },
  mounted() {
    // Charger les utilisateurs au montage du composant
    this.getUsers();
  },
  methods: {
    ...mapActions({
      getUsers: "users/list/getAll",
      resetData: "users/list/resetData",
      getConversations: "conversations/list/getAll",
    }),

    setFilterAssignConversation(option) {
      if (!option || !("id" in option)) return;
      
      this.filter.agent_id = option.id;
      this.getConversations();
    },

    clearFilter() {
      this.filterData = null;
      this.filter.agent_id = null;
      this.getConversations();
    },

    onStartDateChange() {
      // Validation : la date de début ne peut pas être supérieure à la date de fin
      if (this.startDate && this.endDate) {
        if (this.startDate > this.endDate) {
          // La date de début est supérieure à la date de fin
          this.startDate = this.endDate;
          this.startTime = '00:00';
        }
        this.updateStartDateFilter();
      } else if (this.startDate) {
        this.updateStartDateFilter();
      } else {
        this.filter.start_date = null;
        this.getConversations();
      }
    },

    updateStartDateFilter() {
      if (this.startDate && this.startTime) {
        // Validation : si même date, l'heure de début doit être <= heure de fin
        if (this.startDate === this.endDate && this.startTime > this.endTime) {
          this.endTime = '23:59';
        }
        // Combiner date et heure
        this.filter.start_date = `${this.startDate}T${this.startTime}`;
      } else {
        this.filter.start_date = null;
      }
      this.getConversations();
    },

    onEndDateChange() {
      // Validation : la date de fin ne peut pas être inférieure à la date de début
      if (this.endDate && this.startDate) {
        if (this.endDate < this.startDate) {
          // La date de fin est inférieure à la date de début
          this.endDate = this.startDate;
          this.endTime = '23:59';
        }
        this.updateEndDateFilter();
      } else if (this.endDate) {
        this.updateEndDateFilter();
      } else {
        this.filter.end_date = null;
        this.getConversations();
      }
    },

    updateEndDateFilter() {
      if (this.endDate && this.endTime) {
        // Validation : si même date, l'heure de fin doit être >= heure de début
        if (this.endDate === this.startDate && this.endTime < this.startTime) {
          this.endTime = '23:59';
        }
        // Combiner date et heure
        this.filter.end_date = `${this.endDate}T${this.endTime}`;
      } else {
        this.filter.end_date = null;
      }
      this.getConversations();
    },

    clearDateFilter() {
      this.startDate = null;
      this.startTime = '00:00';
      this.endDate = null;
      this.endTime = '23:59';
      this.filter.start_date = null;
      this.filter.end_date = null;

      // Recharger les conversations sans le filtre de date
      this.getConversations();
    },

    getInitials(option) {
      if (!option) return '?';
      const firstname = option.firstname || '';
      const lastname = option.lastname || '';
      return `${firstname.charAt(0)}${lastname.charAt(0)}`.toUpperCase() || '??';
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
/* Personnalisation du multiselect */
.multiselect-custom :deep(.multiselect__tags) {
  @apply border-gray-300 dark:border-gray-600 bg-white dark:bg-slate-700 rounded-lg min-h-[44px] py-1.5 px-3;
}

.multiselect-custom :deep(.multiselect__single) {
  @apply bg-transparent mb-0 text-gray-900 dark:text-gray-100;
}

.multiselect-custom :deep(.multiselect__placeholder) {
  @apply text-gray-500 dark:text-gray-400 mb-0 pt-0;
}

.multiselect-custom :deep(.multiselect__select) {
  @apply h-[44px];
}

.multiselect-custom :deep(.multiselect__select:before) {
  @apply border-gray-400 dark:border-gray-500;
}

.multiselect-custom :deep(.multiselect__content-wrapper) {
  @apply border-gray-300 dark:border-gray-600 bg-white dark:bg-slate-700 rounded-lg shadow-lg mt-1;
}

.multiselect-custom :deep(.multiselect__content) {
  @apply py-2;
}

.multiselect-custom :deep(.multiselect__element) {
  @apply px-2;
}

.multiselect-custom :deep(.multiselect__option) {
  @apply min-h-[60px] px-3 py-0;
}

.multiselect-custom :deep(.multiselect__option--highlight) {
  @apply bg-teal-50 dark:bg-teal-900/20;
}

.multiselect-custom :deep(.multiselect__option--selected) {
  @apply bg-teal-100 dark:bg-teal-900/30 font-semibold;
}

.multiselect-custom :deep(.multiselect__option--selected.multiselect__option--highlight) {
  @apply bg-teal-600 text-white;
}

.multiselect-custom :deep(.multiselect__spinner) {
  @apply bg-white dark:bg-slate-700;
}

.multiselect-custom :deep(.multiselect__spinner:before),
.multiselect-custom :deep(.multiselect__spinner:after) {
  @apply border-t-teal-500;
}

/* Focus state */
.multiselect-custom :deep(.multiselect--active .multiselect__tags) {
  @apply ring-2 ring-teal-500 border-teal-500;
}

/* Scrollbar personnalisée */
.multiselect-custom :deep(.multiselect__content-wrapper::-webkit-scrollbar) {
  width: 6px;
}

.multiselect-custom :deep(.multiselect__content-wrapper::-webkit-scrollbar-track) {
  @apply bg-gray-100 dark:bg-gray-800;
}

.multiselect-custom :deep(.multiselect__content-wrapper::-webkit-scrollbar-thumb) {
  @apply bg-gray-300 dark:bg-gray-600 rounded-full;
}

.multiselect-custom :deep(.multiselect__content-wrapper::-webkit-scrollbar-thumb:hover) {
  @apply bg-gray-400 dark:bg-gray-500;
}
</style>